import { useEffect } from 'react'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../../enums/FormMode'
import { useCrudFormStore } from '../../../Store/hooks/useStore'

import { UseKeeponButtonProps } from './interface'

const resolveValue = <T extends unknown>(
  isKeeponBtn: boolean,
  hasKeeponBtn: boolean,
  externalValue: T,
  primaryValue?: T,
  defaultValue?: T
) => {
  return (
    externalValue ??
    (isKeeponBtn ? primaryValue : hasKeeponBtn ? defaultValue : primaryValue)
  )
}

export const useKeeponButton = ({
  keepon,
  forceShow,
  type: externalType,
  icon: externalIcon,
  children: externalChildren
}: UseKeeponButtonProps) => {
  const { mode, hasKeeponBtn, registerKeeponButton } = useCrudFormStore(state =>
    pick(state, ['mode', 'hasKeeponBtn', 'registerKeeponButton'])
  )

  useEffect(() => {
    if (keepon && mode === FormMode.CREATE) {
      return registerKeeponButton()
    }
  }, [keepon, mode, registerKeeponButton])

  const type = resolveValue(
    !!keepon,
    hasKeeponBtn,
    externalType,
    'primary',
    'primary'
  )
  const icon = resolveValue(!!keepon, hasKeeponBtn, externalIcon)

  const children = externalChildren ?? (keepon ? '提交并继续' : '提交')

  return {
    type,
    icon,
    ghost: hasKeeponBtn && !keepon,
    hide:
      forceShow !== true &&
      (mode === FormMode.READ || (keepon && mode !== FormMode.CREATE)),
    children
  }
}
